import CheckWin from './CheckWin'
import Event from './Event';
export default function missile(war, striker, addEvent) {
    let not_striker;

    if (striker === 'attacker') { not_striker = "defender" } else {
        not_striker = "attacker"
    }
    if (war[striker].maps >= 8) {
        war[striker].maps -= 8

        war[not_striker].resistance = Math.max(0, war[not_striker].resistance - 18)


        let tone = "good"
        if (war[striker].playable === false) {
            tone = "bad"
        }
        addEvent(<Event tone={tone} title={war[striker].name + " Launched a Missile"} text={""} />)

    }
    else {
        addEvent(<Event tone={"neutral"} title={war[striker].name + " dont have enough maps for that"} text={""} />)
    }

    war.winner = CheckWin(war)
    return { ...war }
}